import { render, staticRenderFns } from "./GmRole.vue?vue&type=template&id=1f51c9e2";
import script from "./GmRole.vue?vue&type=script&lang=js";
export * from "./GmRole.vue?vue&type=script&lang=js";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;